import { useEffect, useState } from 'react';

const CSS_VAR = '--dashboard-mobile-keyboard-inset';

/** 手机虚拟键盘弹起时，写入视口底部 inset（供底部岛贴键盘定位）；返回当前 inset px */
export function useMobileKeyboardInset(enabled) {
	const [insetPx, setInsetPx] = useState(0);

	useEffect(() => {
		if (!enabled || typeof window === 'undefined') {
			setInsetPx(0);
			document.documentElement.style.removeProperty(CSS_VAR);
			return undefined;
		}

		const viewport = window.visualViewport;
		if (!viewport) {
			return undefined;
		}

		let rafId = null;

		const update = () => {
			if (rafId !== null) {
				return;
			}
			rafId = window.requestAnimationFrame(() => {
				rafId = null;
				const inset = Math.max(0, Math.round(window.innerHeight - viewport.height - viewport.offsetTop));
				setInsetPx(inset);
				document.documentElement.style.setProperty(CSS_VAR, `${inset}px`);
			});
		};

		const scheduleUpdate = () => {
			update();
			window.setTimeout(update, 120);
			window.setTimeout(update, 360);
		};

		scheduleUpdate();
		viewport.addEventListener('resize', update);
		viewport.addEventListener('scroll', update);
		window.addEventListener('resize', scheduleUpdate);
		window.addEventListener('focusin', scheduleUpdate);
		window.addEventListener('focusout', scheduleUpdate);

		return () => {
			if (rafId !== null) {
				window.cancelAnimationFrame(rafId);
			}
			viewport.removeEventListener('resize', update);
			viewport.removeEventListener('scroll', update);
			window.removeEventListener('resize', scheduleUpdate);
			window.removeEventListener('focusin', scheduleUpdate);
			window.removeEventListener('focusout', scheduleUpdate);
			document.documentElement.style.removeProperty(CSS_VAR);
			setInsetPx(0);
		};
	}, [enabled]);

	return insetPx;
}
